import {
  FileArchiveIcon,
  FileAudioIcon,
  FileDocIcon,
  FileGenericIcon,
  FileImageIcon,
  FilePdfIcon,
  FileSheetIcon,
  FileVideoIcon,
} from './icons';

/**
 * Picks the right icon for a file's MIME type.
 *
 * Lives beside `icons.tsx` rather than inside it: a module that exports both
 * components and plain functions cannot be hot-replaced on its own, so editing
 * any icon would reload the whole app.
 */
export function fileIconFor(mimeType: string) {
  if (mimeType.startsWith('image/')) return FileImageIcon;
  if (mimeType.startsWith('video/')) return FileVideoIcon;
  if (mimeType.startsWith('audio/')) return FileAudioIcon;
  if (mimeType.includes('pdf')) return FilePdfIcon;
  if (mimeType.includes('zip') || mimeType.includes('tar')) return FileArchiveIcon;
  if (mimeType.includes('sheet') || mimeType.includes('csv')) return FileSheetIcon;
  if (mimeType.includes('word') || mimeType.includes('document')) return FileDocIcon;
  return FileGenericIcon;
}
